import { render, staticRenderFns } from "./study_model_list.vue?vue&type=template&id=0bb772b5&scoped=true&"
import script from "./study_model_list.vue?vue&type=script&lang=js&"
export * from "./study_model_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb772b5",
  null
  
)

export default component.exports